import { Font } from '@react-pdf/renderer';
import React, { useEffect, useState } from 'react';
import EditToolsBar from './edit-tools-bar';
import { formatDateThai, formatDateEn } from '@src/utils/format-date-th';
import { useCreateCertificate } from '@src/services/queries/useCertificateQuery';
export type TemplateType = {
    credit_date: string;
    title: string;
    subTile: string;
    totalCarbon: number;
    creditNumber?: string | undefined;
    projectName?: string | undefined;
};

export type TemplateDescType = {
    totalCarbon: number;
    projectName: string;
    numberCredit: string;
};

export type postEventType = {
    name?: string | undefined;
    eventOwner?: string | undefined;
    totalCarbon: number;
    creditNumber?: string | undefined;
    startDate?: string | undefined;
    projectName?: string | undefined;
};

// export const fileTh = `${process.env.PUBLIC_URL}/assets/certificate/certificate-th.png`;
// export const fileEn = `${process.env.PUBLIC_URL}/assets/certificate/certificate-en.png`;
export const fileTh = `th`;
export const fileEn = `en`;
const Certificate = ({ postEvent, eventId }: { eventId: number | string; postEvent: postEventType }) => {
    const date = postEvent.startDate ?? '';
    const [rawTemplate, setRawTemplate] = useState({
        credit_date: 'ZC-' + formatDateEn(postEvent.startDate ?? ''),
        title: `${postEvent.name}`,
        subTile: ` ${formatDateThai(date)} โดย ${postEvent.eventOwner}`,
        totalCarbon: postEvent.totalCarbon,
        creditNumber: `${postEvent.creditNumber}`,
        projectName: `${postEvent.projectName}`,
    });

    const [fileTemplate, setFileTemplate] = useState(fileTh);
    const [urlTemplate, setUrlTemplate] = useState('');

    Font.register({
        family: 'THSan',
        src: `${process.env.PUBLIC_URL}/assets/fonts/TH-Kanit/Kanit-Light.ttf`,
    });

    const { mutateAsync } = useCreateCertificate();

    const getURLCert = async () => {
        const response = await mutateAsync({ eventId: parseInt(eventId as string), lang: fileTemplate });
        setUrlTemplate(response.url);
    };

    useEffect(() => {
        getURLCert();
    }, [fileTemplate]);

    return (
        <div className="w-full relative max-w-screen-lg">
            {urlTemplate && (
                <div className="w-full max-w-screen-lg h-[820px] px-4 py-8">
                    <img src={urlTemplate} alt="template-certificate" />
                </div>
            )}
            {/*   <PDFViewer showToolbar={false} height="920" width={'100%'} className="max-w-screen-lg">
                <Template dataTemplate={rawTemplate} imageBackground={urlTemplate} /> 

                <Document>
                    <Page size="A4" style={StyleSheet.page}>
                        <Image src={urlTemplate} style={StyleSheet.pageBackground} />
                    </Page>
                </Document>
            </PDFViewer>
            */}
            <EditToolsBar
                eventId={eventId}
                dataTemplate={rawTemplate}
                setDataTemplate={setRawTemplate}
                fileTemplate={fileTemplate}
                setFileTemplate={setFileTemplate}
            />
        </div>
    );
};

export default Certificate;
